import styled from "styled-components";
import {SearchInputMobileDefaultBox} from "./search-input-mobile.default.box";

export const SearchInputMobileMrGreenCisBox = styled(SearchInputMobileDefaultBox)`
    margin: 0 1rem;
`;